import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import * as cafesActions from '../../../redux/cafes/actions';
import submitForm from '../../../utils/submitForm';
import { requester } from '../../../utils';

import Spin from '../../../components/loading';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';
import Pagination2 from '../../../components/Pagination2';
import CafeListFilter from './cafeListFilter';
import CafesTable from './CafesTable';

import './styles.scss';
import Table from '../../../components/table';
import { cafeList } from '../../../enums/columns/cafes';
import ENUMS from '../../../enums';

class Cafes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorText: locales('errors.default'),
      errorFlag: false,
      currentPage: 1,
      itemsPerPage: 10,
      selectedRegions: [],
      selectedAmenities: [],
      pageSize: 10,
      cafes: [],
      flag: true,
      sortType: 'asc',
      sortBy: 'createdAt',
      download: false,
      data:[],
      ref: React.createRef()
    };
  }

  componentDidMount() {
    this.sortTable(this.state.sortBy);
  }

  componentDidUpdate(prevProps, prevState) {
    let newCafeList = [];
    this.props.cafes?.map((item) => {
      let newType = '';
      ENUMS.CAFE_TYPE.list.map((enumVal) => {
        if (enumVal.value === item.cafeType) {
          newType = enumVal.title;
        }
      })
      let newItem = { ...item, cafeType: newType }
      newCafeList = [...newCafeList, newItem]
    })
    if (prevState.data.length !== newCafeList.length) {
      this.setState({ data: newCafeList })
    }
  }
  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  applyFilters = (event, btnClicked) => {
    const queryString = submitForm(event, this.state.selectedRegions, this.state.selectedAmenities);
    this.setState({ filter: queryString, download: btnClicked === 'download' ? true : false }, () =>
      this.filterAndSort()
    );
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) {
      query = `${filter}&${sort}`;
    } else if (filter) {
      query = `${filter}`;
    } else if (sort) {
      query = `${sort}`;
    }
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      if (this.state.download) {
        // this.props.getCafesInExcel(searchQuery);
      } else {
        this.props.getCafes(searchQuery);
      }
    });
  };

  sortTable = query => {
    this.setState({ sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  onSortCafes = (sortField, sortType) => {
    this.setState({ pageNumber: 0, sort: `sort=${sortField}-${sortType}` }, () => this.filterAndSort());
  };

  setSelectedAmenities = selected => {
    this.setState({ selectedAmenities: selected ? [...selected] : [] });
  };

  onSelectRegions = selectedRegions => {
    this.setState({ selectedRegions: selectedRegions ? [...selectedRegions] : [] });
  };

  onPageChanged = currentPage => {
    this.setState({ currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.getCafes(query);
    });
  };

  activateCafe = id => {
    this.props.changeCafeStatus(id, ENUMS.CAFE_STATUS.values.CONFIRMED).then(() => {
      AlertAndConfirmation({
        title: locales('titles.activision'),
        text: locales('titles.activatedSuccessfully'),
        type: 'success'
      });
    });
  };

  disableCafe = id => {
    this.props.changeCafeStatus(id, ENUMS.CAFE_STATUS.values.DISABLED).then(() => {
      AlertAndConfirmation({
        title: locales('titles.deactivision'),
        text: locales('titles.deactivatedSuccessfully'),
        type: 'success'
      });
    });
  };

  exportExcel = e => {
    e.preventDefault();

    const query = this.state.query || 'sort=createdAt-desc';

    this.props.getCafesExcelFile(query).then(res => {
      const { filename, blob } = res;

      var ref = this.state.ref;
      ref.current.href = URL.createObjectURL(blob);
      ref.current.download = filename;

      ref.current.click();
    });
  };

  render() {
    let { totalRecords } = this.props.cafe;
    let { currentPage, pageSize, itemsPerPage, sortType } = this.state;

    let loading =
      this.props.loading || this.props.changeCafeStatusLoading || this.props.getCafesExcelFileLoading;
    let error = this.props.error || this.props.changeCafeStatusError || this.props.getCafesExcelFileError;
    let failed = this.props.failed || this.props.changeCafeStatusFailed || this.props.getCafesExcelFileFailed;
    let message =
      this.props.message || this.props.changeCafeStatusMessage || this.props.getCafesExcelFileFailedMessage;

    return (
      <Spin spinning={loading}>
        <section className="page-header">
          <h1>{locales('titles.cafesManagement')}</h1>
          <div className="form-actions">
            <Link to="/cafes/add" className="btn btn-primary w-5">
              <i className="fa fa-plus" />
              {locales('titles.add.new.cafe')}
            </Link>
            <button className="btn btn-success" onClick={this.exportExcel}>
              <i className="fal fa-file-excel mx-1"></i>
              {locales('labels.excel.output')}
            </button>
            <a style={{ display: 'none' }} href="empty" ref={this.state.ref}>
              ref
            </a>
          </div>
        </section>

        {this.state.errorFlag && this.handleAlert()}

        <section className="panel panel-default">
          {error ? (
            <div className="alert alert-danger">{locales('messages.server.error')}</div>
          ) : (
            <>
              {failed && <div className="alert alert-danger">{message}</div>}

              <div className="panel-heading">
                <i className="fas fa-list-alt px-1" />
                {locales('titles.cafesList')}
              </div>

              <div className="panel-body">
                <CafeListFilter
                  selectedAmenities={this.setSelectedAmenities}
                  filterAndSort={this.filterAndSort}
                  onSelectRegions={this.onSelectRegions}
                  applyFilters={this.applyFilters}
                />
                  {this.state.data.length === this.props.cafes.length &&
                  <Table
                  columns={cafeList}
                    dataSource={this.state.data}
                  loading={loading}
                  action={{ activateCafe: this.activateCafe, disableCafe: this.disableCafe }}
                  sort={{ type: sortType, action: this.sortTable }}
                  pagination={{
                    currentPage: currentPage,
                    pageSize: pageSize,
                    totalCount: totalRecords,
                    onPageChange: this.onPageChanged
                  }}
                />}
                {/* 
                <CafesTable
                  pageNumber={currentPage}
                  pageSize={itemsPerPage}
                  sortType={sortType}
                  sortTable={this.sortTable}
                  onSortCafes={this.onSortCafes}
                />

                <div className="pagination-container">
                  <Pagination2
                    totalRecords={totalRecords || 0}
                    pageLimit={itemsPerPage}
                    pageNeighbours={2}
                    onPageChanged={this.onPageChanged}
                    currentPage={this.state.currentPage}
                  />
                </div> */}
              </div>
            </>
          )}
        </section>
      </Spin>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.cafesReducer.getCafesLoading,
    fail: state.cafesReducer.getCafesFailed,
    error: state.cafesReducer.getCafesError,
    message: state.cafesReducer.getCafesMessage,

    cafes: state.cafesReducer.cafes,
    cafe: state.cafesReducer.cafe,

    changeCafeStatusLoading: state.cafesReducer.changeCafeStatusLoading,
    changeCafeStatusFailed: state.cafesReducer.changeCafeStatusFailed,
    changeCafeStatusError: state.cafesReducer.changeCafeStatusError,
    changeCafeStatusMessage: state.cafesReducer.changeCafeStatusMessage,

    getCafesExcelFileLoading: state.cafesReducer.getCafesExcelFileLoading,
    getCafesExcelFileFailed: state.cafesReducer.getCafesExcelFileFailed,
    getCafesExcelFileError: state.cafesReducer.getCafesExcelFileError,
    getCafesExcelFileFailedMessage: state.cafesReducer.getCafesExcelFileFailedMessage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCafes: query => dispatch(cafesActions.getCafes(query)),
    getCafesExcelFile: query => dispatch(cafesActions.getCafesExcelFile(query)),
    changeCafeStatus: (cafeId, status) => dispatch(cafesActions.changeCafeStatus(cafeId, status))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Cafes);
